import { useEffect, useState } from 'react'

export function useDelayedLoading(isLoading: boolean, delayMs = 300, minDisplayTimeMs = 500): boolean {
  const [delayedLoading, setDelayedLoading] = useState(false)
  const [showTimestamp, setShowTimestamp] = useState<number | null>(null)

  useEffect(() => {
    let showTimer: ReturnType<typeof setTimeout> | undefined
    let hideTimer: ReturnType<typeof setTimeout> | undefined

    if (isLoading && !delayedLoading) {
      showTimer = setTimeout(() => {
        setDelayedLoading(true)
        setShowTimestamp(Date.now())
      }, delayMs)
    } else if (!isLoading && delayedLoading) {
      if (showTimestamp) {
        const elapsedTime = Date.now() - showTimestamp
        if (elapsedTime < minDisplayTimeMs) {
          hideTimer = setTimeout(() => {
            setDelayedLoading(false)
            setShowTimestamp(null)
          }, minDisplayTimeMs - elapsedTime)
        } else {
          setDelayedLoading(false)
          setShowTimestamp(null)
        }
      } else {
        setDelayedLoading(false)
      }
    }

    return () => {
      if (showTimer) clearTimeout(showTimer)
      if (hideTimer) clearTimeout(hideTimer)
    }
  }, [isLoading, delayedLoading, delayMs, minDisplayTimeMs, showTimestamp])

  return delayedLoading
}
